import { type AxiosResponse } from 'axios';
import { post } from '@utilities';
import { type GenerateImageRequest } from './interfaces';

export const generateImage = async (data: GenerateImageRequest): Promise<AxiosResponse> =>
	await post('aimagine/generate', data);

/** POST /document/upload - get upload URLs for AImagine input images. */
export const uploadDocument = async (body: {
	reference_id: string;
	reference_type: string;
	documents: Array<{
		category: string;
		sub_category: string;
		attachments: Array<{ file: string; cover_image: boolean }>;
		document_id?: number;
	}>;
}): Promise<AxiosResponse> => await post('document/upload', body);

/** POST /document/activate - activate uploaded documents. */
export const activateDocument = async (data: { documentIds: number[] }): Promise<AxiosResponse> =>
	await post('document/activate', data);
